<template>
  <div :style="dinamicStyle" class="skeleton-animation">
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

type PropTypes = {
  shape?: 'square' | 'round' | 'circle' | '--'
  width?: string | number
  height?: string | number
}

const props = withDefaults(defineProps<PropTypes>(), {
  shape: 'square',
  width: '100%',
  height: '10px'
})

const dinamicStyle = computed(() => {
  const _width = props.width.toString()?.replace('px','');
  const _height = props.height.toString()?.replace('px','');
  return {
    width: _width?.toString()?.includes('px') ? _width as string: _width + 'px',
    height: _height?.toString()?.includes('px') ? _height as string: _height + 'px'
  };
});

</script>

<style scoped>
div{
  background-color: #EEEEEE;
}
</style>
